import fun from "../../../util/util";
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import Axios from "../../../axios"
export default{ 
    namespaced:true,
    state:{
        stationList:[], //电站列表
        stationSelVal:"", //选择的电站
        refreshTime:"", //数据刷新间隔时间
        iconType:1,  //图标的类型
        fullScreen:null, //是否展示3d全屏
        sysNameShow:true, // 切换的系统名称是否显示
    },
    mutations:{
        //修改选择电站
        setStation(state,val){
            if(state.stationSelVal !== val){
                state.stationSelVal = val
                //切换电站让页面重新加载
                 location.reload()
            } 
            
        },
        setRefreshTime(state,time){
            if(fun.isNull(time)){
                state.refreshTime = 5000
            } else {
                state.refreshTime = time
            }
            
        },

        setIconType(state,iconType){
            state.iconType = iconType
        },
        setFullScreen(state,fullScreen){
            state.fullScreen = fullScreen
        },
        
        //获取电站列表
        loadStationList(state,list){
            state.stationList = list
            if(fun.isNull(state.stationSelVal)){
                if(list.length > 0){
                    state.stationSelVal = list[0].id 
                }
                
            }      
        },

        //设置系统名称是不显示
        setSysNameShow(state,val){
            state.sysNameShow = val
        },
    },
    actions:{
        //查询电站列表
        async getStationList(context,data){
            await  Axios.post(myApi.getListByEmsSign, data).then(res=>{
                if(res.data.code === myConst.code.success){
                    context.commit("loadStationList",res.data.data)
                } else {
                    context.commit("loadStationList",[])
                }
            }).catch(()=>{ context.commit("loadStationList",[])})
        },

        async getStationInfo(context,id){
            await Axios.get(myApi.getBusGetOne + "?id=" + id).then(res=>{
                if(res.data.code === myConst.code.success){
                    context.commit("setRefreshTime", res.data.data.refreshInterval*1000)
                } else {
                    context.commit("setRefreshTime", 5000)
                }
            }).catch(()=>{context.commit("setRefreshTime", 5000)})
        }
    }
}